import {Timeline, TimelineEvent} from 'react-event-timeline'
import React, { Component, PropTypes } from 'react';
import classnames from 'classnames'
import Loading from 'components/UI/Loading'
import moment from 'moment'
import locale from './locale'
import './Timeline.scss'
import {confirm} from 'util/confirm'
import {alert} from 'util/alert'
import __R, { userCan } from 'containers/__R'

class ContactTimeline extends Component {

  static propTypes = {
    tasks: PropTypes.array,
  }

  constructor(props) {
    super(props);
  }

  render() {
    const {tasks, deleteTask, editTask} = this.props

    if(!tasks){
      return (<div />)
    }

    return (
      <div className={classnames('react-timeline-container', {})}>
        {/* { fetching && <Loading /> } */}
        <Timeline className='Timeline' lineColor='#EBEBED' lineStyle={{ width: 1 }} >
          {tasks.map((task, key) => {

            return(
              <div key={key}>
                <TimelineEvent
                  className='timeline-event-container'
                  title={<div className='createdAt'>{moment(task.created_at).format('YYYY-MM-DD hh:mm A')}</div>}
                  contentStyle={{boxShadow: 'none', padding: '0px'}}
                  bubbleStyle={{background: 'none', color: 'white', fontSize: '15px', border: 'none'}}
                  titleStyle={{color: '#11151E', fontSize: '20px', fontWeight: '600'}}
                  createdAt={task.editor_name + ' ' + __('created this note', locale)}
                  icon={<img className='school-success-icon' src={require('data/images/note@2x.png')} />}
                >
                  <div dangerouslySetInnerHTML={{__html: task.content}}></div>
                  <__R can='edit_contact_notes' by='disable'>
                    <button className='btn-link' onClick={() => {
                      editTask(task.id, task)
                    }}>{__('Edit', locale)}</button>
                  </__R>
                  <__R can='edit_contact_notes' by='disable'>
                    <button className='btn-link' onClick={() => {
                      deleteTask(key, task.id)
                    }}>{__('Delete', locale)}</button>
                  </__R>
                </TimelineEvent>
              </div>
            )
          })}
        </Timeline>
      </div>
    );
  }
}

export default ContactTimeline;



// WEBPACK FOOTER //
// ./src/components/UI/ContactTimeline/index.js